import {fieldValue} from "../common/NamaCommon";
import {DropDownListWidget} from "../widgets/DropDownListWidget";
import {translateId} from "../common/Translator";

export function comboTemplate(fieldId, trimmedFieldId) {

    return (dataItem) => {
        let value = fieldValue(dataItem, trimmedFieldId);
        return translateId(value);
    }
}

export function comboColumnEditor(fieldMetadata, trimmedFieldId, grid, id) {
    return (container, options) => {
        let widget = new DropDownListWidget({owner: grid, fieldMetadata, cellOptions: options, id: id});
        widget.inputName = options.field;
        grid.afterAddingToGridAction(widget, options, trimmedFieldId, container);
    }
}